// extracted by mini-css-extract-plugin
module.exports = {"notification":"__4Yl6YxEB","btn":"VQgI1kFk","title":"ovVKAE0n","desc":"q0yHtVbJ"};